import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { THEFT_REGISTRIES_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const createTheftRegistryAction = createAsyncThunk(
    'order/createTheftRegistryAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.post(THEFT_REGISTRIES_PATH, data);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const createTheftRegistrySlice = createSlice({
    name: 'createTheftRegistrySlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(createTheftRegistryAction.pending, () => STATE__API__STARTED);
        builder.addCase(createTheftRegistryAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(createTheftRegistryAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const createTheftRegistryState = (state) => state.order.createTheftRegistry;
export default createTheftRegistrySlice.reducer;
